<template>
  <div id="app">
    <Navbar v-if="navbar"></Navbar>
    <router-view/>
    <Footer></Footer>
  </div>
</template>

<script>
import Navbar from "./components/navbar/Navbar.vue";
import Footer from "./components/Footer.vue";
export default {
  name: 'app',
  data() {
    return {
      navbar: true,
    }
  },
  components: {
    Navbar,
    Footer,
  },
  mounted() {
    let recaptchaScript1 = document.createElement('script')
    recaptchaScript1.setAttribute('src', 'https://cdn.jsdelivr.net/npm/popper.js@1.16.0/dist/umd/popper.min.js')
    document.head.appendChild(recaptchaScript1);

    let recaptchaScript = document.createElement('script')
    recaptchaScript.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/materialize/1.0.0/js/materialize.min.js')
    document.head.appendChild(recaptchaScript);
    },
}
</script>


<style>
  @import url("https://fonts.googleapis.com/css?family=Material+Icons|Material+Icons+Outlined|Material+Icons+Two+Tone|Material+Icons+Round|Material+Icons+Sharp");
  @import url('https://cdnjs.cloudflare.com/ajax/libs/materialize/1.0.0/css/materialize.min.css');
  @import url('https://fonts.googleapis.com/css?family=Roboto:100,300,400,500&display=swap');
  @import './assets/styles/style.css';


</style>
